import { environment } from "src/environments/environment";
// ng build --configuration=test
// ng build --configuration=production
export const ip = environment.ip;
export const geoserver_url = environment.geoserver_url;

export const serviceurl = environment.serviceurl;
export const imageurl = environment.imgUrl;

export const projection = 'EPSG:4326';
export const mapcenter = [0, 0];

// Map Zoom Configuration - Centralized for consistency across all map components
export const DEFAULT_ZOOM = 6;
export const MIN_ZOOM = 0;
export const MAX_ZOOM = 18;
export const BURG_LAYER_MIN_ZOOM = 4;
export const BURG_LAYER_MAX_ZOOM = 16;

// City Map Zoom Configuration (uses different projection EPSG:3857)
export const CITY_DEFAULT_ZOOM = 18;
export const CITY_MIN_ZOOM = 17;
export const CITY_MAX_ZOOM = 20;

export const colorcode = ["rgba(214,109,111,0.2)", "rgba(214,139,109,0.2)", "rgba(214,202,109,0.2)", "rgba(214,186,109,0.2)", "rgba(214,155,109,0.2)", "rgba(210,214,109,0.2)", "rgba(214,191,109,0.1)", "rgba(86, 147, 220, 0.2)", "rgba(86, 220, 147, 0.2)", "rgba(86, 147, 220, 0.2)", "rgba(86, 220, 147, 0.2)", "rgba(86, 147, 220, 0.2)"];
export const WORLD_TUMBLER_URL = environment.WORLD_TUMBLER_URL;
export const elevationRanges = [
  '-13000ft to -2301',
  '-2300 to -599',
  '-600 to -101',
  '-100 to -1',
  '0 to 2000',
  '2001 to 4000',
  '4001 to 8000',
  '8001 to 14000',
  '14001 to 24000',
];
export const geozoneRanges = [
  'Arctic Tundra',
  'Temper North',
  'Subtropic North',
  'Tropical North',
  'Equatorial',
  'Tropical South',
  'Subtropic South',
  'Temper South',
  'Antarctica',
];
export const biomeRanges = [
  'Hot Desert',
  'Grassland',
  'Cold Desert',
  'Savanna',
  'Tiaga',
  'Temperate Deciduous Forest',
  'Glacier',
  'Tropical Seasonal Forest',
  'Temperate Rainforest',
  'Tundra',
  'Wetland',
  'Tropical Rain Forest',
  'Temper Coniferous Forest',
  'Marine'
];
export const ruralLocationRanges = [
  'Random Encounter',
  'Battlefield',
  'Boat / Shipwreck',
  'Bridge',
  'Camp / Fort',
  'Castle / Tower',
  'Cavern / Cave',
  'Cemetery',
  'Dungeon',
  'Tower',
  'Lighthouse',
  'Mine',
  'Temple / Monestary',
  'Watch Tower',
];
export const urbanLocationRanges = [
  'Random Encounter',
  'Arena / Colosseum',
  'Castle / Tower',
  'Catacombs',
  'Cemetery',
  'Estate / Mansion',
  'Farm lands',
  'Harbor / Docks',
  'Jail / Prison / Asylum',
  'Library',
  'Market',
  'Sewers',
  'Slums',
  'Temple / Monestary',
];
export const shopsRanges = [
  'Adventuring Gear',
  'Animals and Mounts',
  'Clothing and Accessories',
  'Entertainment and Leisure',
  'General Goods',
  'Illicit and Underworld',
  'Inn / Hotel',
  'Luxury Goods / Jeweler',
  'Magic and Alchemy',
  'Weapons and Armor',
  'Guild Hall',
  'Mortuary',
  'Armorer',
];

